/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { BillingCycle } from './BillingCycle';
// @ts-ignore
import {
// @ts-ignore
    BillingCycleFromJSON,
// @ts-ignore
    BillingCycleFromJSONTyped,
// @ts-ignore
    BillingCycleToJSON,
} from './BillingCycle';
// @ts-ignore
import type { TimeWindow } from './TimeWindow';
// @ts-ignore
import {
// @ts-ignore
    TimeWindowFromJSON,
// @ts-ignore
    TimeWindowFromJSONTyped,
// @ts-ignore
    TimeWindowToJSON,
} from './TimeWindow';

/**
 * 
 * @export
 * @interface Subscription
 */
export interface Subscription {
    /**
     * Subscription status for this customer.
     * @type {string}
     * @memberof Subscription
     */
    status: SubscriptionStatusEnum;
    /**
     * Payment readiness/state, if applicable.
     * @type {string}
     * @memberof Subscription
     */
    paymentStatus?: SubscriptionPaymentStatusEnum | null;
    /**
     * 
     * @type {BillingCycle}
     * @memberof Subscription
     */
    billingCycle?: BillingCycle;
    /**
     * 
     * @type {Date}
     * @memberof Subscription
     */
    startedAt?: Date | null;
    /**
     * 
     * @type {TimeWindow}
     * @memberof Subscription
     */
    currentPeriod?: TimeWindow;
    /**
     * 
     * @type {Date}
     * @memberof Subscription
     */
    nextBillingAt?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof Subscription
     */
    cancelAtPeriodEnd?: boolean;
    /**
     * Convenience flag for clients.
     * @type {boolean}
     * @memberof Subscription
     */
    isActive?: boolean;
}


/**
 * @export
 */
export const SubscriptionStatusEnum = {
    None: 'none',
    Active: 'active',
    Canceled: 'canceled',
    PastDue: 'past_due',
    Paused: 'paused'
} as const;
export type SubscriptionStatusEnum = typeof SubscriptionStatusEnum[keyof typeof SubscriptionStatusEnum];

/**
 * @export
 */
export const SubscriptionPaymentStatusEnum = {
    Ok: 'ok',
    ActionRequired: 'action_required'
} as const;
export type SubscriptionPaymentStatusEnum = typeof SubscriptionPaymentStatusEnum[keyof typeof SubscriptionPaymentStatusEnum];


/**
 * Check if a given object implements the Subscription interface.
 */
// @ts-ignore
export function instanceOfSubscription(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

// @ts-ignore
export function SubscriptionFromJSON(json: any): Subscription {
    return SubscriptionFromJSONTyped(json, false);
}

// @ts-ignore
export function SubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Subscription {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'paymentStatus': !exists(json, 'payment_status') ? undefined : json['payment_status'],
        'billingCycle': !exists(json, 'billing_cycle') ? undefined : BillingCycleFromJSON(json['billing_cycle']),
        'startedAt': !exists(json, 'started_at') ? undefined : (json['started_at'] === null ? null : new Date(json['started_at'])),
        'currentPeriod': !exists(json, 'current_period') ? undefined : TimeWindowFromJSON(json['current_period']),
        'nextBillingAt': !exists(json, 'next_billing_at') ? undefined : (json['next_billing_at'] === null ? null : new Date(json['next_billing_at'])),
        'cancelAtPeriodEnd': !exists(json, 'cancel_at_period_end') ? undefined : json['cancel_at_period_end'],
        'isActive': !exists(json, 'is_active') ? undefined : json['is_active'],
    };
}

// @ts-ignore
export function SubscriptionToJSON(value?: Subscription | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'payment_status': value.paymentStatus,
        'billing_cycle': BillingCycleToJSON(value.billingCycle),
        'started_at': value.startedAt === undefined ? undefined : (value.startedAt === null ? null : value.startedAt.toISOString()),
        'current_period': TimeWindowToJSON(value.currentPeriod),
        'next_billing_at': value.nextBillingAt === undefined ? undefined : (value.nextBillingAt === null ? null : value.nextBillingAt.toISOString()),
        'cancel_at_period_end': value.cancelAtPeriodEnd,
        'is_active': value.isActive,
    };
}

